import cartActionTypes from '../cart/actionTypes';
import createReducer from '../utils/createReducer';
import type { AddressesState } from '../../types';

const initialState: AddressesState = {
  shippingAddress: undefined,
};

export default createReducer(initialState)({
  [cartActionTypes.CART_LOAD_SUCCESS]: (state: AddressesState, action: any) => {
    const {
      shippingData: { shippingAddress },
    } = action.cart;
    return {
      ...state,
      shippingAddress,
    };
  },
});
